import Vue from 'vue'
import { mapActions } from 'vuex'

import App from './app.vue'
import store from './store/index'
import router from './router/index'

import('./assets/less/app.less')

import components from './components/index.js'

Vue.use(components)

window.wzWebApp = new Vue({
  router,
  store,
  el: '#webApp',
  render: h => h(App),
  computed: {},
  methods: {
    ...mapActions('account', ['loadAccount']),
    init() {
      // this.loadAccount()
      // this.timerStart({})
    },
    destroy() {
      // this.timerStop()
    }
  },
  async created() {
    this.init()
  },
  beforeDestroy() {
    this.destroy()
  }
})
